import { formatDistanceToNow } from 'date-fns'

import { Icon } from '@loadsmart/miranda-react'

import { type Thread } from 'assistant/domain/Thread'
import { displayTitle } from 'assistant/domain/threadTitle'

import {
  StyledIconButton,
  StyledRow,
  StyledRowActions,
  StyledSelect,
  StyledTime,
  StyledTitle,
} from './ThreadList.styles'

type ThreadRowProps = {
  thread: Thread
  active: boolean
  onSelect: () => void
  onRename: () => void
  onDelete: () => void
}

export default function ThreadRow({ thread, active, onSelect, onRename, onDelete }: ThreadRowProps) {
  const updatedAt = new Date(thread.updatedAt)

  return (
    <StyledRow $active={active}>
      <StyledSelect type="button" onClick={onSelect} aria-current={active ? 'page' : undefined}>
        <StyledTitle $active={active}>{displayTitle(thread)}</StyledTitle>
        {!Number.isNaN(updatedAt.getTime()) && (
          <StyledTime dateTime={thread.updatedAt}>
            {formatDistanceToNow(updatedAt, { addSuffix: true })}
          </StyledTime>
        )}
      </StyledSelect>
      <StyledRowActions>
        <StyledIconButton type="button" aria-label="Rename conversation" onClick={onRename}>
          <Icon name="pencil" size="16px" />
        </StyledIconButton>
        <StyledIconButton type="button" aria-label="Delete conversation" onClick={onDelete}>
          <Icon name="trash" size="16px" />
        </StyledIconButton>
      </StyledRowActions>
    </StyledRow>
  )
}
